/**
 * e3 PDP 图片画廊交互。
 *
 * part-product-media-swiper(-mobile) 从 theme-us/uk 移植而来，那两个主题的
 * <swiper-media-images> / <page-dots-swiper> 定义在 sections.js / theme.js 里，
 * 本主题（Impact 6.5.0）没有对应实现，故在此补齐。
 *
 * 依赖 window.Swiper，layout/theme.liquid 中排在 swiper14-bundle.min.js 之后加载。
 */

/** 缩略图 / 圆点列表：点击派发 swiperControl:select，冒泡给外层 <swiper-media-images> */
class PageDotsSwiper extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.items = Array.from(this.children);
    this.items.forEach((button, index) =>
      button.addEventListener('click', () => this.select(index), { signal: this._abortController.signal })
    );
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  get selectedIndex() {
    return this.items.findIndex((button) => button.getAttribute('aria-current') === 'true');
  }

  select(selectedIndex, dispatchEvent = true) {
    const item = this.items[selectedIndex];
    if (!item) return;

    if (this.hasAttribute('align-selected')) {
      this.scrollTo({
        left: item.offsetLeft - this.clientWidth / 2 + item.clientWidth / 2,
        behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
      });
    }

    if (this.selectedIndex === selectedIndex) return;

    this.items.forEach((button, index) =>
      button.setAttribute('aria-current', selectedIndex === index ? 'true' : 'false')
    );

    if (dispatchEvent) {
      this.dispatchEvent(
        new CustomEvent('swiperControl:select', { bubbles: true, detail: { index: selectedIndex } })
      );
    }
  }
}

/** 主图轮播：初始化 Swiper，并与缩略图列表双向同步 */
class SwiperMediaImages extends HTMLElement {
  connectedCallback() {
    this._initSwiper();
    this.addEventListener('swiperControl:select', (event) => this.swiper?.slideToLoop(event.detail.index));
  }

  disconnectedCallback() {
    this.swiper?.destroy();
    this.swiper = null;
  }

  _initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      effect: 'fade',
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      on: {
        slideChange: (swiper) => this.querySelector('page-dots-swiper')?.select(swiper.realIndex, false)
      }
    });
  }
}

if (!customElements.get('page-dots-swiper')) {
  customElements.define('page-dots-swiper', PageDotsSwiper);
}

if (!customElements.get('swiper-media-images')) {
  customElements.define('swiper-media-images', SwiperMediaImages);
}
